module.exports = __webpack_public_path__ + "media/images/add-resource-placeholder-76cb0bd98cda51f912df0621280e9401.svg";